<div class="h-100" >
  <cdk-virtual-scroll-viewport *ngIf="displayList" class="h-100" style="overflow-x:hidden;" itemSize="20">
    <ng-container *cdkVirtualFor="let  Effectif of ListToDisplay">
      <div class="d-flex flex-wrap justify-content-between align-items-center mt-2">
        <div [ngClass]="[Effectif.IsSelected ? 'bold q-check radio' : 'q-check radio']" *ngIf="service.Options.SelectionMode == SelectionMode.SINGLE">
          <input type="radio" id="{{service.Options.Title}}-{{Effectif.Id}}-{{service.Options.IdInstances}}"
                 (click)="OnSelectChange(Effectif)"
                 [checked]="Effectif.IsSelected" />
          <label for="{{service.Options.Title}}-{{Effectif.Id}}-{{service.Options.IdInstances}}" class="mb-0">
            <span style=" width: 15px; height: 15px; margin-bottom: 4px;"></span>
          </label>
        </div>
        <div [ngClass]="[Effectif.IsSelected ? 'bold q-check' : 'q-check']" *ngIf="service.Options.SelectionMode == SelectionMode.MULTIPLE else ValueToDisplay">
          <input type="checkbox" id="{{service.Options.Title}}-{{Effectif.Id}}-{{service.Options.IdInstances}}" (change)="OnSelectChange(Effectif)" [ngModel]="Effectif.IsSelected" />
          <label for="{{service.Options.Title}}-{{Effectif.Id}}-{{service.Options.IdInstances}}" class="d-flex mb-0 align-items-center">
            <span></span>
            <ng-container *ngTemplateOutlet="ValueToDisplay"></ng-container>
          </label>
        </div>
        <ng-template #ValueToDisplay>
          <!--<div *ngIf="(service.Options.RenderType == RenderType.PPPHOTO || service.Options.RenderType == RenderType.PP) && ShowPicture"
         class="mr-2"
         [title]="Effectif.ToolTip">
      <img src="{{Effectif.Picture}}" onError="this.src='http://192.168.81.25:8081/Images/Initial/_Profil.png'" loading="lazy" class="ImgUser">
    </div>-->

          <div class="col q-effectifName" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding: 0;"
               [title]="Effectif.ToolTip">{{Effectif.Text}}</div>

          <div class="render__template"><ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit:Effectif}"></ng-container></div>

        </ng-template>
        <i *ngIf="Effectif.IdClient && Effectif.IdClient.length == 0 && service.Options.RenderType == RenderType.PP && service.Options.Mode != ModeEffectif.PREINSCRITS" title="Cet apprenant n’est plus lié à un client du stage" class="q-pointer q-c-warning fa-solid fa-triangle-exclamation" style="width: 10px;text-align: center;"></i>
        <i *ngIf="Mode == CRUD.UPDATE && Effectif.TextWarning && Effectif.TextWarning != ''" class="fas fa-exclamation-triangle q-c-warning mx-2 q-pointer" title="{{Effectif.TextWarning}}"></i>
        <!-- Permet d'edit le commentaire sur le lien  si CanCommentLien == true-->
        <i *ngIf="service.Options.CanCommentLien == true && Mode == CRUD.UPDATE" class="fas fa-info-circle q-c-main mx-2 q-pointer" title="{{Effectif.LinkInfos}}" (click)="OpenModalComment(ModalCommentaire,Effectif)"></i>
        <!-- si input CRUD sur CREATE -->
        <i *ngIf="Mode == CRUD.CREATE" class="fas fa-plus-circle q-c-main iconsEffectifs mx-2 q-pointer" title="Ajouter" (click)="AddEffectifToSelect(Effectif)"></i>
        <!-- si input CRUD sur UPDATE -->
        <i *ngIf="Mode == CRUD.UPDATE && Effectif.IdActionCo == ''" class="fas fa-edit q-c-main mx-2 q-pointer" title="Editer" (click)="OpenBoEffectif(ModalBO,Effectif.Id)"></i>
        <i *ngIf="Mode == CRUD.UPDATE && Effectif.IdActionCo != ''" class="fas fa-edit q-c-main mx-2 q-pointer" title="Ouvrir l'action commerciale" (click)="OpenActionCo(Effectif)"></i>

        <!-- si input CRUD sur DELETE -->
        <i *ngIf="Mode == CRUD.DELETE && service.Options.RenderType != RenderType.PMSTAGE" class="fas fa-times-circle q-c-main iconsEffectifs mx-2 q-pointer" (click)="RemoveEffectifFromSelect(Effectif)"></i>
        <i *ngIf="Mode == CRUD.DELETE && service.Options.RenderType == RenderType.PMSTAGE" class="fas fa-times-circle q-c-main iconsEffectifs mx-2 q-pointer" (click)="RemoveElements([Effectif.Id])"></i>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>





<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modal>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <q-bodisplay class="w-100 h-100 mb-5" [item]="service.Model" (sendEvent)="OnSaveBo($event,modal)"></q-bodisplay>
  </div>
</ng-template>

<!-- Modal Confirmation suppression -->

<ng-template #ModalConfirmDelete let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" style="max-height: calc(80vh - 130px); min-height: 350px; overflow: auto;">
      <div class="container">
        <p *ngIf="displayApprenantInfo" style=" font-size: 15px;">
          Ce(s)
          <span class="fa-stack mx-1 fa-xs" style="margin-right: 0px !important;">
            <i class="fas fa-square fa-stack-2x q-c-main"></i>
            <i class="fas fa-check fa-stack-1x q-c-white"></i>
          </span>
          Apprenant(s)
          <span class="mr-1"><i title="apprenant appartenant à plusieurs clients de ce stage" class="fas fa-exclamation-circle q-c-primary"></i></span>
          appartienne(nt) à plusieurs clients de ce stage, confirmez leur retrait du stage.
        </p>
        <p *ngIf="displayClientInfo" style=" font-size: 15px;">le <span class="q-legend-style">Client</span> ne peut être supprimé tant qu'une ou plusieurs <span class="q-c-danger">Conventions facturées</span> sont cochées pour suppression.</p>
        <ng-container *ngFor="let client of effectifsToDelete">
          <fieldset class="row q-fieldset m-2"
                    [ngClass]="{'warning-border-color' : !client.Deletable}"
                    style="max-width:80vw;">
            <legend>{{client.Text}}</legend>

            <div class="col-12 col-md-auto mb-2 mr-5">
              <div class="row q-c-main">Apprenants</div>

              <ng-container *ngFor="let stagiaire of client?.Contacts; let i = index">
                <div class="row">
                  <div class="q-check" [ngClass]="{'q-c-danger': !stagiaire.Deletable}">
                    <input type="checkbox" disabled id="{{client.Text}}-stagiaire-{{i}}" [(ngModel)]="stagiaire.IsSelected" />
                    <label for="{{client.Text}}-stagiaire-{{i}}">
                      <span></span>{{stagiaire.Text}}
                      <i *ngIf="stagiaire.CheckBoxDelete" title="apprenant appartenant à plusieurs clients de ce stage" class="fas fa-exclamation-circle q-c-primary"></i>
                    </label>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="col-12 col-md-auto mb-2">
              <div class="row q-c-main">Conventions</div>

              <ng-container *ngFor="let convention of client?.Conventions; let i = index">
                <div class="row">
                  <div class="q-check" [ngClass]="{'q-c-danger': !convention.Deletable}">
                    <input type="checkbox" disabled id="{{client.ValueToDisplay}}-convention-{{i}}" [ngModel]="convention.IsSelected" (ngModelChange)="OnConventionChange(convention, client, $event)" />
                    <label for="{{client.ValueToDisplay}}-convention-{{i}}">
                      <span></span>{{convention.Titre}}
                      <i *ngIf="convention.CheckBoxDelete" title="convention appartenant à plusieurs stages" class="fas fa-exclamation-circle q-c-primary"></i>
                    </label>
                  </div>
                </div>
              </ng-container>
            </div>
          </fieldset>
        </ng-container>
      </div>
    </div>
    <div class="modal-footer"></div>
    <div class="row justify-content-end m-2">
      <button (click)="modal.dismiss()" class="q-btn q-primary"><i class="fas fa-times mr-2"></i>Annuler</button>
      <button *ngIf="!displayClientInfo" (click)="DeleteEffectifs(modal)" class="q-btn q-danger"><i class="fas fa-trash mr-2"></i>Supprimer</button>
    </div>
  </div>
</ng-template>

<!-- Modal Edition commentaire de Lien -->

<ng-template #ModalCommentaire class="modal-dialog-centered" let-modal>
  <div class="modal_content">
    <div class="d-flex justify-content-end mr-3 mt-3">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-header justify-content-center">
      <div class="q-text-xl q-c-main">Editer le commentaire sur le lien</div>
    </div>
    <div class="d-flex justify-content-center px-4">
      <textarea [(ngModel)]="InfoLink" class="w-100 q-infoLink"></textarea>
    </div>
    <div class="modal-footer">
      <button class="q-btn q-success" (click)="SaveLinkInfos()">Valider</button>
    </div>
  </div>
</ng-template>
